import has from "lodash/fp/has";
import set from "lodash/fp/set";
import type { AnySchema } from "yup";
import { ValidationError } from "yup";

export default function validateFormValuesAgainstSchema<T>(schema: AnySchema<T>) {
  return (values: any) => {
    try {
      schema.validateSync(values, {
        stripUnknown: true,
        abortEarly: false,
      });
    } catch (err) {
      if (err instanceof ValidationError && err.inner) {
        return err.inner.reduce((errors: Record<string, unknown>, error: ValidationError) => {
          if (error.path && !has(error.path, errors)) {
            return set(error.path, error.message, errors);
          }

          return errors;
        }, {});
      }
    }

    return {};
  };
}
